module.exports = __webpack_public_path__ + "mo/img/swiper_bg03.a0ce0a52.png";